import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';

import { useAuth } from '@/modules/Auth/hooks/useAuth';
import queryKeys from '@/modules/shared/query/queryKeys';
import { AwsConfigApiGateway } from '@/utils/config/api';

async function disableTeamMember(teamMemberEmail: string, token: string | undefined) {
  const body = {
    userEmail: teamMemberEmail,
  };
  const response = await axios.post<string>(`${AwsConfigApiGateway.pooledTenantApiUrl}/team-members/disable`, body, {
    headers: {
      'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
      Authorization: 'Bearer ' + token,
    },
  });
  return response.data;
}

export function useDisableTeamMember() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<string, Error, string>({
    mutationFn: (data) => disableTeamMember(data, user?.signInUserSession.idToken.jwtToken),
    onSuccess: () => {
      // Refetch team members query after successful disable
      queryClient.refetchQueries([queryKeys.teamMembers]);
    },
  });
}
